import { FormControlLabel, RadioGroup as MUIRadioGroup, Radio } from "@mui/material";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import styles from "./RadioGroup.module.scss";

export interface RadioGroupProps {
    identifier: string;
    input: InputComponentProps<string>;
    attributes?: { row?: boolean; disabled?: boolean };
    options: {
        value: string;
        label: string;
    }[];
}

export const RadioGroup = ({ identifier, input, attributes, options }: RadioGroupProps) => {
    return (
        <MUIRadioGroup
            {...input}
            {...attributes}
            aria-label={identifier}
            className={styles.radioGroupContainer}
        >
            {options.map((option) => (
                <FormControlLabel
                    value={option.value}
                    key={option.label}
                    label={option.label}
                    control={<Radio />}
                />
            ))}
        </MUIRadioGroup>
    );
};
